import React from "react";
import useSeo from "../hooks/useSeo";
import { storeConfig } from "../config/store.config";

const CONTENT = {
  shipping: {
    title: "Shipping Policy",
    meta: "9'One Store shipping policy template.",
    sections: [
      ["Overview", "This is an editable shipping policy template. Shipping rates, serviceable locations and delivery timelines are not yet configured and must be finalised before launch."],
      ["Processing Time", "Orders are confirmed via WhatsApp. Processing and dispatch timelines will be communicated at the time of order. (Placeholder.)"],
      ["Delivery", "Delivery estimates and courier partners are to be confirmed. We currently do not claim any specific delivery guarantee. (Placeholder.)"],
      ["Charges", "Shipping charges, if any, will be confirmed at order. No free-shipping claim is made. (Placeholder.)"],
    ],
  },
  returns: {
    title: "Return, Refund & Exchange Policy",
    meta: "9'One Store return, refund and exchange policy template.",
    sections: [
      ["Overview", "This is an editable returns / refund / exchange policy template. Final terms must be reviewed and confirmed before launch."],
      ["Eligibility", "Return and exchange eligibility windows and conditions are to be defined. (Placeholder.)"],
      ["Process", "To request a return or exchange, contact us on WhatsApp with your order details and we will guide you. (Placeholder.)"],
      ["Refunds", "Refund methods and timelines are to be confirmed. No specific commitment is made until finalised. (Placeholder.)"],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    meta: "9'One Store privacy policy template.",
    sections: [
      ["Overview", "This is an editable privacy policy template and should be reviewed by a qualified professional before launch."],
      ["Information We Collect", "In Phase 1, we do not operate customer accounts or a customer database. Delivery details you enter are used only to generate a WhatsApp order message and are not stored on this website."],
      ["Local Storage", "Your cart, wishlist and recently viewed items are stored in your browser's local storage for convenience. No sensitive personal data is stored there."],
      ["Contact", `For any privacy questions, contact ${storeConfig.primaryContactName} at ${storeConfig.primaryEmail}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    meta: "9'One Store terms and conditions template.",
    sections: [
      ["Overview", "This is an editable terms & conditions template and should be reviewed by a qualified professional before launch."],
      ["Products", "Product imagery and descriptions shown are temporary placeholders and may not represent final inventory. Prices and availability are subject to confirmation."],
      ["Orders", "Orders are placed via WhatsApp. An order is only confirmed once our team acknowledges it. (Placeholder.)"],
      ["Contact", `For any questions, contact ${storeConfig.primaryContactName} at ${storeConfig.primaryPhoneIntl}.`],
    ],
  },
};

const Policy = ({ type }) => {
  const data = CONTENT[type] || CONTENT.terms;
  useSeo({ title: data.title, description: data.meta, path: `/${type}` });

  return (
    <div className="animate-fade-in">
      <div className="border-b border-ink">
        <div className="container-9one py-12">
          <p className="label-mono text-ink/50">Policies</p>
          <h1 className="mt-2 font-display text-4xl uppercase tracking-tight sm:text-6xl">{data.title}</h1>
        </div>
      </div>
      <div className="container-9one max-w-3xl py-12">
        <div className="mb-8 border border-ink bg-cream px-4 py-3">
          <p className="font-mono text-[11px] uppercase tracking-wider text-ink/70">
            Template — needs final review before launch
          </p>
        </div>
        <div className="space-y-8">
          {data.sections.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-display text-2xl uppercase tracking-tight">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-ink/70">{p}</p>
            </div>
          ))}
          <p className="pt-4 font-mono text-xs text-ink/40">
            Last updated: placeholder · {storeConfig.storeName} · {storeConfig.domain}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Policy;
